import * as t from 'io-ts';

import {makeEnumRuntimeType} from './apiTypes';
import {AttachmentVisualContentTypesEnum, parseVisualContentType} from './attachmentModel';

/*
 * Runtime types.
 */

const RHighlightRange = t.readonly(
  t.type({
    start: t.Integer,
    length: t.Integer,
  }),
);

const RHighlight = t.readonly(
  t.type({
    text: t.string,
    ranges: t.readonlyArray(RHighlightRange),
  }),
);

export enum SearchActivityTypesEnum {
  ATTACHMENT = 'attachment',
  COMMENT = 'comment',
  DRAFT = 'draft',
  MESSAGE = 'message',
}

const RSearchActivity = t.readonly(
  t.intersection([
    t.type({
      id: t.Integer,
    }),
    t.partial({
      visualType: makeEnumRuntimeType(SearchActivityTypesEnum),
      visualContentType: makeEnumRuntimeType(AttachmentVisualContentTypesEnum),
      authorId: t.number,
    }),
  ]),
);

const RConversationHighlightDirty = t.readonly(
  t.intersection([
    t.type({
      conversationId: t.Integer,
    }),
    t.partial({
      recipient: RHighlight,
      summary: RHighlight,
      subject: RHighlight,
      attachments: RHighlight,
      searchActivity: RSearchActivity,
    }),
  ]),
);

/*
 * Types.
 */

export interface HighlightRangeModel extends t.TypeOf<typeof RHighlightRange> {}
export interface HighlightModel extends t.TypeOf<typeof RHighlight> {}
export interface SearchActivityModel extends t.TypeOf<typeof RSearchActivity> {}
export interface ConversationHighlightModel extends t.TypeOf<typeof RConversationHighlightDirty> {}

export const RConversationHighlight = t.clean<ConversationHighlightModel>(RConversationHighlightDirty as any);

/*
 * IO methods.
 */

/* eslint no-underscore-dangle: 0 */
export function parseConversationHighlight(src: any) {
  return {
    conversationId: src.id,
    recipient: src._highlight_ranges['contact.display_name'] || undefined,
    summary: src._highlight_ranges.summary || undefined,
    subject: src._highlight_ranges.subject || undefined,
    attachments: src._highlight_ranges.attachments || undefined,
    searchActivity: (src._search_activity && parseSearchActivity(src._search_activity)) || undefined,
  };
}

function parseSearchActivity(src: any) {
  return {
    id: src.id,
    visualType: src.type,
    visualContentType: src.content_type ? parseVisualContentType(src.content_type.toLowerCase()) : undefined,
    authorId: src.author_id ?? undefined,
  };
}
